import { render } from "./MainStandalone.vue?vue&type=template&id=b933f242&scoped=true"
import script from "./MainStandalone.vue?vue&type=script&lang=js"
export * from "./MainStandalone.vue?vue&type=script&lang=js"

import "./MainStandalone.vue?vue&type=style&index=0&id=b933f242&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b933f242"]])

export default __exports__